import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import querystring from 'querystring';

import axiosClient from 'utils/client';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  isFilterUpdated: false,
};

const LMS_BASE_URL = () => getConfig().LMS_BASE_URL;

const coursesAPI = {
  async fetchInProgressCourses({ club, page = 1, search }: any) {
    const params = {
      ...(club && {
        club,
      }),
      ...(search && {
        search,
      }),
      page,
    };

    let qs = querystring.stringify(params);
    if (qs) {
      qs = `?${qs}`;
    }

    const result = await axiosClient({
      url: `${LMS_BASE_URL()}/api/bcm/progress/${qs}`,
      method: 'GET',
    });
    return result;
  },
};

export const getInProgressCourses = createAsyncThunk(
  'courses/getInProgressCourses',
  async (props: any) => {
    const response = await coursesAPI.fetchInProgressCourses(props);
    return response.data;
  },
);

const slice = createSlice({
  name: 'inProgressCourses',
  initialState: initialState,
  reducers: {
    updateFilters: (state: any) => {
      return {
        ...state,
        isFilterUpdated: true,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getInProgressCourses.fulfilled, (state, action) => {
        const { resetInitialState } = action.meta.arg;

        if (resetInitialState) {
          return {
            data: action.payload,
            isLoading: false,
            isError: false,
            isFilterUpdated: false,
          };
        }

        return {
          data: {
            next: get(action, 'payload.next', null),
            count: get(action, 'payload.count', 0),
            results: [
              ...get(state, `data.results`, []),
              ...get(action, 'payload.results', []),
            ],
          },
          isLoading: false,
          isError: false,
          isFilterUpdated: false,
        };
      })
      .addCase(getInProgressCourses.pending, state => {
        state.isLoading = true;
      })
      .addCase(getInProgressCourses.rejected, state => {
        state.isError = true;
        state.isLoading = false;
        state.isFilterUpdated = false;
      });
  },
});

export const { updateFilters } = slice.actions;

export default slice.reducer;
